<div class="outside-box">
  @if(!production) {
  <div
    style="background-color: red; padding: 5px; width: 200px; height: fit-content; margin: 0 auto; border-radius: 5px; position: fixed; top: 10px; left: calc(50% - 100px);">
    <p style="color: white; margin: 0; text-align: center;">
      <strong>Development Mode</strong>
    </p>
  </div>
  }
  <div class="inside-box">
    <div class="fixed-container">
      <div style="text-align: center;">
        <img src="/assets/images/cropped-Hanwha-Philly-Shipyard_option-4.png" style="width: 300px;" />
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div style="text-align: center; margin-bottom: 20px;">
          <p style="font-size: 30px;">Sign In</p>
        </div>
        <mat-form-field style="width: 100%" appearance="outline">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" required>
        </mat-form-field>

        <mat-form-field style="width: 100%" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" required>
        </mat-form-field>

        <div style="display: flex; justify-content: center; margin-top: 20px;">
          <button mat-flat-button color="primary" type="submit"
            [disabled]="loginForm.invalid || accountService.isLoading">Login</button>
        </div>
        @if (msalEnabled) {
        <div class="microsoft-login">
          <span>or</span>
          <button mat-stroked-button type="button" [disabled]="msalInteractionInProgress || microsoftLoginStarting"
            (click)="signInWithMicrosoft()">
            Sign in with Microsoft
          </button>
        </div>
        }
      </form>
    </div>
  </div>
</div>